import { render, staticRenderFns } from "./numberOfPackages.vue?vue&type=template&id=2a3a16b4&"
import script from "./numberOfPackages.vue?vue&type=script&lang=js&"
export * from "./numberOfPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports